(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["button~dropdown~index~input~progress~table~upload"],{

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    medium: function medium() {
      return Boolean(!this.large && !this.small);
    },
    // large => lg
    // small => sm
    sizeableClasses: function sizeableClasses() {
      var sizeCls = 'meg-size';

      switch (this.size) {
        case 'large':
          sizeCls += '-lg';
          break;

        case 'small':
          sizeCls += '-sm';
          break;

        default:
          break;
      }

      return sizeCls;
    }
  }
});

/***/ })

}]);